<template src="./index.html"></template>

<script>
import { getYear, getFinancialPeriod, getDetailType, reportSubmit, inquiryAliasConfig, getCACodeDesc, getTCodeByNumber } from '../../../../api/home.js';
import { getdata } from './data.js';
export default {
	name: 'VoucherData',
	data() {
		return {
			checkList: ['0'],
			//基本信息
			formlistjbxx: getdata().formlistjbxx,
			formdatajbxx: getdata().formdatajbxx
		};
	},
	watch: {
		'formdatajbxx.cains': function(indexVal, oldVal) {
			this.formdatajbxx.qij1 = '';
			this.formdatajbxx.qij2 = '';
			this.GainCwqj(indexVal);
		}
	},
	mounted() {},
	created() {
		this.searrchForData();
	},
	methods: {
		getdatajbxx() {
			let params = {};
			params.json = JSON.stringify({ name: '凭证数据后台任务', taskDesc: 'test', subType: '15' });
			let param = {};
			param.cains = [];
			param.cains.push(this.formdatajbxx.cains.toString());
			param.qij = [];
			param.qij.push(this.formdatajbxx.qij1.toString());
			param.qij.push(this.formdatajbxx.qij2.toString());
			params.param = JSON.stringify(param);
			reportSubmit(params).then(res => {
				if (res.data.code == '200') {
					this.$message.success('生成成功');
					this.$router.push({
						path: '/ReportTask',
					});
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		//生成按钮验证
		generate() {
			this.$refs.taxformjbxx.submitForm();
		},
		//重置
		empty() {
			this.formdatajbxx = getdata().formdatajbxx;
			this.$nextTick(() => {
				this.$refs.taxformjbxx.clearValidate();
			});
		},
		//初始化查询
		searrchForData() {
			this.formlistjbxx = getdata().formlistjbxx;
			this.GainNd();
			this.GainKmdm();
			this.GainFXDM();
		},
		//获取年度
		GainNd() {
			let params = {};
			getYear().then(res => {
				this.formdatajbxx.cains = new Date().getFullYear();
				for (var i = res.data.data.max; i >= res.data.data.min; i--) {
					this.formlistjbxx[0].selectval.push({
						label: i,
						value: i
					});
				}
			});
		}, //获取财务期间
		GainCwqj(year) {
			let params = {};
			params.year = year;
			getFinancialPeriod(params).then(res => {
				if (res.data.code == '200') {
					this.formlistjbxx[1].selectval = res.data.data.map(v => {
						return {
							label: v.name,
							value: v.value
						};
					});
					this.formlistjbxx[2].selectval = res.data.data.map(v => {
						return {
							label: v.name,
							value: v.value
						};
					});
				} else {
					this.formdatajbxx.qij1 = '';
					this.formdatajbxx.qij2 = '';
					this.formlistjbxx[1].selectval = [];
					this.formlistjbxx[2].selectval = [];
				}
				let currencyMonth = new Date().getMonth() + 1;
				this.formdatajbxx.qij1 = currencyMonth;
				this.formdatajbxx.qij2 = currencyMonth;
			});
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
